const en = {
  common: {
    role: {
      ADMIN: "Super admin",
      TENANT_ADMIN: "Admin",
      OPERATOR: "Operator",
      PM: "Project manager",
      MACHINE: "Machine",
    },
    action: {
      close: "Close",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      cancel: "Cancel",
      save: "Save",
      print: "Print",
      confirm: "Confirm",
      select: "Select",
      assign: "Assign",
      view: "View",
      yes: "Yes",
      no: "No",
      download: "Download",
      reset: "Reset",
      new: "New",
      copy: "Copy",
    },
    table: {
      delete: "delete",
      deleteRows: "Delete %length% rows",
      add: "New",
      edit: "edit",
      close: "close",
      refresh: "refresh",
      noRowsLabel: "No data to display",
    },
    label: {
      loading: "Loading",
      asset: "Asset",
      name: "Name",
      type: "Type",
      createdAt: "Created at",
      from: "From",
      for: "for",
      all: "All",
      documents: "Documents",
      start: "Start",
      end: "End",
      releaseHere: "Drop ",
      clickOrDrag: "Click or drag a file",
      inputSearch: {
        name: "Name",
        createdAt: "Created at",
      },
      tag: "Tag",
      value: "Value",
      empty: {
        assets: "No assets created",
        documents: "No documents to display",
        sensors: "No sensors in your assets",
        tickets: "No tickets to display",
        artifacts: "No production to display",
        events: "No events to display",
      },
      next: "Next",
      back: "Back",
      yes: "Yes",
      no: "No",
    },
  },
  drawer: {
    dashboard: "Dashboard",
    assets: "Asset",
    archive: "Archive",
    monitoring: "Monitoring",
    users: "Users",
    groups: "Groups",
    tenants: "Tenants",
    documents: "Documents",
    configuration: "Configuration",
    insights: "Insights",
    audits: "Audit Log",
    tickets: "Tickets",
    tasks: "Activities",
    prognosis: "Prognosis",
    diagnosis: "Diagnosis",
    artifacts: "Production",
    checklist: "Checklist",
    divider: "Divider",
    tags: "Tags",
    goods: "Goods and Waste",
    calls: "Calls",
    admin: "Administration",
  },
  deleteDialog: {
    title: "Delete",
    text: "Are you sure you want to proceed with the deletion?",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  form: {
    edit: "Edit",
    new: "New",
    reset: "Reset",
    save: "Save",
  },
  paginator: {
    rowsPerPage: "Rows",
    of: "of",
  },
  calendar: {
    date: "Date",
    time: "Time",
    event: "Event",
    allDay: "All Day",
    week: "Week",
    work_week: "Work Week",
    day: "Day",
    month: "Month",
    previous: "Previous",
    next: "Next",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    today: "Today",
    agenda: "Agenda",
    noEventsInRange: "No events in this range",
    until: "Until",
  },
  pages: {
    login: {
      text: "Sign in to Predimain",
      username: "Username",
      password: "Password",
      rememberMe: "Remember me",
      login: "Sign in",
    },
    tenants: {
      clearDisk: "Clear Disks",
      clearData: "Clear data",
      clearDataDescription:
        "This operation will delete all measurement data collected for the selected tenant. Are you sure you want to proceed?",
      clearDiskDescription:
        "This operation will delete all documents present on the disk of the selected tenant. Are you sure you want to proceed?",
    },
    home: {
      addTask: {
        title: "Plan your activities",
        description:
          "Schedule preventive maintenance plans on corporate assets, define time windows, and assign qualified technical staff",
      },
      addArtifact: {
        title: "Production",
        description:
          "Plan your orders and production on a Gantt chart. Structure tasks, set temporal dependencies, and control resources for each artifact.",
      },
      addTicket: {
        title: "Ticket Management",
        description:
          "Manage user tickets, assign priorities, and monitor progress.",
      },
      tenants: {
        title: "Tenants",
      },
      sensors: {
        title: "Sensors",
      },
      profile: {
        welcome: "Welcome",
        title: "Profile",
        today: "Today is",
        lastLogin: "Last login",
      },
      lastAudits: {
        title: "Logs",
        date: "Date and time",
        user: "Name",
        description: "Description",
        has: "has",
        action: {
          configurePermissions: "configured permissions",
          create: "created",
          update: "modified",
          delete: "deleted",
          status: "moved",
          message: "commented",
          copy: "copied",
          "add-task": "added task",
          "update-task": "updated task",
          upload: "uploaded document",
          tag: "changed the tag of",
          "update-checklist": "modified the checklist of",
          "answer-checklist": "filled in the checklist of",
          "clear-checklist-answer": "cleared a checklist answer of",
        },
      },
      tickets: {
        title: "Tickets",
        performance: "Performance",
        performanceNotAvailable: "Statistics not available",
      },
      tasks: {
        title: "Tasks",
      },
      assets: {
        title: "Assets",
      },
    },
    assets: {
      title: "Assets",
      documents: "Documents",
      tickets: "Tickets",
      tasks: "Tasks",
      notFound: "Asset not found",
      noSearchResults: "No assets match your search",
      confirmDrop: {
        title: "Confirm move",
        text: "Are you sure you want to move asset %name% into %target%?",
        textNoParent: "Are you sure you want to move asset %name%?",
        dropRoot: "Drop here to move to root",
        confirm: "Move",
      },
    },
    archive: {
      sensor: "Sensor",
      from: "Start",
      to: "End",
      chart: "Chart",
      table: "Table",
      date: "Date",
      hour: "Hour",
      value: "Value",
      all: "All",
      filters: "Filters",
    },
    prognosis: {
      asset: "Asset",
      from: "Start",
      to: "End",
      chart: "Chart",
      table: "Table",
    },
    users: {
      tab1: "Users",
      tab2: "Groups",
      editCredentials: "Credentials",
      detail: "User detail",
      showDetail: "Detail",
      notFound: "User not found or not accessible",
      artifactTasks: "Production tasks",
      noArtifactTasks: "No production tasks assigned",
      delete: {
        user: "Confirm deletion of the user from the group?",
        group: "Confirm deletion of the group?",
      },
    },
    audits: {
      filterByType: "Filter by type",
    },
    documents: {
      search: "Search",
      creationDate: "Date",
      uploadedBy: "Uploaded By",
      noDocuments: "No documents found",
      category: "Category",
      resetFilter: "Clear filters",
      file: "File",
      addFile: "Add file",
      addFileDescription: "The files will be saved in:",
      delete: "Delete",
      tag: "Tag",
      view: {
        folders: "Folders",
        table: "List",
      },
      open: "Open",
      download: "Download",
      goTo: {
        asset: "Go to asset",
        task: "Go to task",
        ticket: "Go to ticket",
        artifact: "Go to production",
      },
      folders: {
        assets: "Assets",
        artifacts: "Productions",
        other: "Miscellaneous",
      },
      rootFolder: "Root folder",
      location: "Location",
      selectAll: "Select all",
      selected: "selected",
    },
    artifacts: {
      hour: "Hourly",
      quarterDay: "Quarter Day",
      halfDay: "Half Day",
      day: "Day",
      week: "Week",
      month: "Month",
      qyear: "Quarter",
      year: "Year",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      hideTable: "Hide table",
      showTable: "Show table",
      from: "Start Date",
      to: "End Date",
      assignee: "Assigned To",
      duration: "Duration",
      days: "days",
      progress: "Progress",
      dependencies: "Dependencies",
      view: {
        gantt: "Gantt",
        table: "table",
      },
      editTask: {
        new: "New task",
        edit: "Edit task",
        editDescription: "Edit task %name%",
        newDescription: "Add a new subtask to %name%",
        name: "Name",
        description: "Description",
        assignee: "Assignee",
        asset: "Asset",
        start: "Start date",
        end: "End date",
      },
      deleteTask: {
        title: "Delete task",
        text: "Are you sure you want to delete task %name%?",
        confirm: "Delete",
      },
      changeTaskDates: {
        title: "Change dates",
        text: "Do you want to set task %name% from %start% to %end%?",
        confirm: "Change",
      },
      assigned: {
        empty: "You have no assigned tasks.",
        fill: "Fill in",
        noChecklist: "No checklist",
        artifactProgress: "Production %progress%% complete",
      },
      answer: {
        text: "Answer",
        select: "Select",
        none: "None",
        attachment: "Attachment",
        upload: "Attach file",
        read: "I have read and understood",
        completed: "%done% of %total% steps completed",
      },
      checklist: {
        title: "Checklist",
        description:
          "Define the steps the assignee of task %name% has to complete",
        empty: "No steps yet: add one to start.",
        addStep: "Add step",
        question: "Question",
        readText: "Text to read",
        options: "Options",
        optionsRequired: "Add at least one option",
        moveUp: "Move up",
        moveDown: "Move down",
        type: {
          label: "Type",
          TEXT: "Free text",
          SINGLE_CHOICE: "Single choice",
          MULTIPLE_CHOICE: "Multiple choice",
          SELECT: "Dropdown",
          FILE: "Attachment",
          READ: "Reading",
        },
      },
    },
    goods: {
      recycle: {
        title: "Dispose",
        step0: "Select the DPP",
        step1: "Select the disposal company",
        step2: "Enter the pickup address",
        step3: "Confirm the disposal request",
        confirm: "Confirm",
        confirmText:
          "By clicking confirm, an email will be sent with the entered data to the selected disposal company",
        address: "Address",
      },
    },
    admin: {
      tenant: "Company",
      chatbot: "Chatbot",
    },
  },
  entity: {
    tenant: {
      title: "Tenant",
      name: "Name",
      email: "Email",
      img: "Image",
      primaryColor: "Primary color",
      secondaryColor: "Secondary color",
      menu: "Menu",
      users: "Users",
      diskUsage: "Disk usage",
      alertThreshold: "Threshold alert",
      alertSilence: "Silence alert",
    },
    user: {
      title: "User",
      name: "Name",
      surname: "Surname",
      username: "Username",
      role: "Role",
      password: "Password",
      avatar: "Avatar",
      email: "Email",
      phone: "Phone",
      img: "Photo",
      lastLogin: "Last login",
    },
    group: {
      title: "group",
    },
    asset: {
      title: "Asset",
      type: "Type",
      name: "Name",
      description: "Description",
      location: "Location",
      status: "Status",
      start: "Start",
      end: "End",
      img: "Image",
      metadata: "Metadata",
      assignee: "Assignee",
      sensor_scalar: "Scalar sensor",
      sensor_multivalue: "Multivalue sensor",
      building: "Building",
      production: "Production",
      product: "Product",
      machine: "Machinery",
      vehicle: "Vehicle",
      installationDate: "Installation Date",
      estimatedEndDate: "Estimated End Date",
    },
    building: {
      title: "Building",
    },
    machine: {
      title: "Machinery",
    },
    sensorscalar: {
      title: "Scalar sensor",
    },
    sensormultivalue: {
      title: "Multivalue sensor",
    },
    production: {
      title: "Production",
    },
    vehicle: {
      title: "Vehicle",
    },
    product: {
      title: "Product",
    },
    task: {
      title: "Task",
      name: "Name",
      description: "Description",
      assignee: "Assignee",
      asset: "Asset",
      start: "Start",
      end: "End",
      recurring: "Recurring",
      recurrenceRule: "Recurrence rule",
      recurrenceEnd: "Recurrence end",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      tags: "Tags",
    },
    ticket: {
      title: "Ticket",
      createdAt: "Created at",
      name: "Title",
      description: "Description",
      assignee: "Assignee",
      asset: "Asset",
      status: "Status",
      ip: "In progress",
      todo: "To do",
      done: "Completed",
      user: "User",
      updatedAt: "Updated at",
      reporter: "Reported by",
      info: "Info",
      messages: "Messages",
      noMessages: "No messages",
      unassigned: "Unassigned",
      untagged: "Untagged",
      priority: {
        label: "Priority",
        0: "Low",
        1: "Medium",
        2: "High",
      },
      tags: "Tags",
    },
    sensor: {
      title: "Sensor",
      name: "Name",
      type: "Type",
      color: "Color",
      thresholdMin: "Minimum threshold",
      thresholdMax: "Maximum threshold",
      min: "Minimum value",
      max: "Maximum value",
      scalar: "Scalar",
      multivalue: "Multivalue",
      columns: "Columns",
      focus: "Focus",
      filters: "Filters",
      valueFilter: {
        header: "Value filters",
        add: "Add filter",
        values: "Values",
        column: "Column",
      },
    },
    document: {
      title: "Document",
    },
    measure: {
      title: "Measurement",
    },
    diagnosis: {
      title: "Diagnosis",
      healthIndex: "Health Index",
      prevalentState: "Prevalent State",
      severity: "Average Severity",
      timestamp: "Date",
    },
    prognosis: {
      title: "Prognosis",
      rul: "RUL (Hours)",
      failureDate: "Estimated Failure Date",
      failureProbability: "Failure Probability",
      timestamp: "Timestamp",
      noData: "No data",
    },
    artifact: {
      title: "Production",
      name: "Name",
      description: "Description",
      assignee: "Assignee",
      asset: "Asset",
      start: "Start",
      end: "End",
      img: "Image",
      progress: "Progress",
    },
    tag: {
      title: "Tag",
      key: "Key",
      label: "Label",
      description: "Description",
      color: "Color",
    },
    goods: {
      title: "Waste",
      name: "Name",
      description: "Description",
      img: "Image",
      recycled: "Recycled",
      category: "Category",
      category1: "Non-hazardous waste",
      category2: "Hazardous waste",
      category3: "WEEE",
      category4: "Healthcare waste",
      category5: "Construction and demolition waste",
      category6: "Industrial waste",
      category7: "Agricultural waste",
    },
    call: {
      title: "Call",
      caller: "Caller",
      callee: "Callee",
      startedAt: "Start",
      endedAt: "End",
      duration: "Duration",
      outcome: {
        label: "Outcome",
        all: "All",
        completed: "Completed",
        missed: "Missed",
        rejected: "Rejected",
      },
      summary: "Summary",
    },
  },
  userActions: {
    settings: "Settings",
    logout: "Logout",
    light: "Light",
    dark: "Dark",
    system: "System",
    language: "Language",
    theme: "Theme",
    logoutDialog: {
      title: "Confirm Logout",
      text: "Are you sure you want to end the current session and log out?",
      exit: "Logout",
      cancel: "Cancel",
    },
    search: {
      title: "Search",
      placeholder: "Search...",
      button: "Search",
      type: {
        asset: "Asset",
        document: "Document",
        task: "Task",
        ticket: "Ticket",
        artifact: "Production",
      },
    },
  },
  notifications: {
    title: "Notifications",
    empty: "No notifications",
    "task-created": "New task",
    "task-updated": "Task updated",
    "ticket-created": "New ticket",
    "ticket-message": "New message",
    "ticket-updated": "Ticket updated",
    "ticket-status-updated": "Ticket moved",
    prognosis: "New prognosis",
    diagnosis: "New diagnosis",
  },
  permissions: {
    title: "Configure permissions",
    description:
      "Select an item from the data catalog and configure the permissions to associate with the selection",
    table: {
      title: "Configure permissions",
      groupUser: "Group/User",
      canView: "Can view",
      canEdit: "Can edit",
      canDelete: "Can delete",
    },
  },
  chatbot: {
    title: "Assistant",
    open: "Open chat",
    close: "Close chat",
    new: "New conversation",
    empty: "Ask the assistant something",
    placeholder: "Write a message",
    send: "Send",
    provider: "Provider",
    model: "Model",
    assistant: "Assistant",
    noProviders: "No models available",
    configure: "Configure the chatbot",
    notConfiguredAdmin: "Set the API key and model on the Chatbot page",
    notConfigured: "The chatbot is not configured, contact the administrator.",
    selectTenant: "Select a company to use the chatbot.",
    error: {
      default: "Unable to complete the request",
      unavailable: "Provider is not configured: missing API key",
      rejected: "The provider rejected the API key",
      rateLimit: "Too many requests, try again shortly",
      selectTenant: "Select a tenant to use the chatbot.",
      disabled: "The chatbot is disabled for this tenant.",
    },
    suggestions: {
      title: "To do",
      checklist: {
        one: "task with a checklist to complete",
        other: "tasks with a checklist to complete",
        prompt: "Let's fill in the checklist",
      },
      myTickets: {
        one: "ticket assigned to you",
        other: "tickets assigned to you",
        prompt: "Which tickets are assigned to me?",
      },
    },
    choices: {
      send: "Send",
    },
    action: {
      confirm: "Confirm",
      cancel: "Cancel",
      done: "Done",
      failed: "Not done",
      cancelled: "Cancelled",
      superseded: "Replaced by a newer proposal",
      cancelledMessage: "Action cancelled",
    },
    settings: {
      title: "Chatbot settings",
      enabled: "Chatbot enabled",
      apiKey: "API key",
      showKey: "Show key",
      hideKey: "Hide key",
      models: {
        loading: "Loading models",
        missingKey: "Save this provider's API key first.",
        error: "Unable to load models",
      },
      documents: {
        title: "Documents",
        hint: "The chatbot uses the documents uploaded in PrediMain and updates on its own.",
        reindex: "Reindex now",
        indexedOne: "indexed",
        indexedMany: "indexed",
        skippedOne: "skipped",
        skippedMany: "skipped",
        failedOne: "failed",
        failedMany: "failed",
        embedding: "Embedding service is not configured",
      },
    },
  },
  error: {
    0: "An error occurred",
    101: "The requested content does not exist",
    105: "Forbidden",
    401: "Authentication failed",
    500: "Unable to complete the operation",
    forbidden: {
      title: "Access denied",
      text: "You don't have permission to view this resource.",
      back: "Back to home",
    },
    sessionExpired: "Session expired",
    validation: {
      required: "Required field",
      duplicate: "Value already exists",
      endDateAfterStartDate: "The end date must be after the start date",
      type: {
        number: "The field must be a number",
      },
    },
  },
};

export default en;
